/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
// This lib is under 1kb gzipped - maybe we move to api later on
import Card from '../../../components/card/card';
import Slug from '../../../components/slug/slug';
import FCLink from "../../../components/fc_link/fc_link";

// eslint-disable-next-line
class VideoIndexPage extends Component {
  constructor() {
    super();
    this.renderVideoPlaylist = this.renderVideoPlaylist.bind(this);
    this.renderVideoCard = this.renderVideoCard.bind(this);
  }

  renderVideoCard (videoData) {
    return <Card
      key={videoData.mediaid}
      className={'all-feed'}
      env={this.props.config.env}
      hasExcerpt={true}
      metadata={{
        link:  `/video/${videoData.slug}/${videoData.mediaid}`,
        title: videoData.title,
        excerpt: videoData.description,
        featured_image: {
          source: videoData.image
        }
      }}
    />;
  }

  renderVideoPlaylist (playlist) {
    return (
      <section key={playlist.feedid}>
        <FCLink
        title={`${playlist.title}`}
        to={`/videos/playlist/${playlist.slug}/${playlist.feedid}`}
        key={playlist.feedid}
      >
        <Slug
          slugName={`${playlist.title}`}
          className="category-page"
        />
      </FCLink>
        <section>
          {playlist.playlist.map(this.renderVideoCard)}
        </section>
      </section>
    );
  }

  render() {
    if (this.props.status === 404 || this.props.status === 500) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.videoIndexPage.isLoading) {
      return (
        <section className="video-page">
          <article className="video-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug
            slugName={`Fast Company Videos`}
            className="category-page"
          />
          {
            get(this.props, 'jwPlaylistIndex.data.playlists', [])
              .map(this.renderVideoPlaylist)
          }
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    videoIndexPage: state.videoIndexPage,
    jwPlaylistIndex: state.jwPlaylistIndex
  };
}

VideoIndexPage.propTypes = {
  config: PropTypes.shape(),
  status: PropTypes.number,
  videoIndexPage: PropTypes.shape(),
  jwPlaylistIndex: PropTypes.shape()
};

export default withRouter(connect(mapStateToProps)(VideoIndexPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/video_index_page/video_index_page.js